import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	row1: {
		display: "grid",
		gridGap: theme.spacing(9),
		gridTemplateColumns: "1fr",
		gridTemplateRows: "auto auto auto",
		margin: theme.spacing(5, 0, 7),
		[theme.breakpoints.up("sm")]: {
			gridTemplateColumns: "1fr 1fr",
			gridTemplateRows: "auto",
			margin: theme.spacing(5, 0, 0)
		},
		[theme.breakpoints.up("md")]: {
			margin: theme.spacing(5, 0, 9)
		},
		[theme.breakpoints.up("lg")]: {
			gridTemplateColumns: "1fr 1fr 530px",
			margin: theme.spacing(5, 0, 6)
		}
	},
	column2: {
		[theme.breakpoints.up("sm")]: {
			marginLeft: "auto"
		},
		[theme.breakpoints.up("lg")]: {
			marginLeft: 0
		}
	},
	column3: {
		[theme.breakpoints.up("sm")]: {
			gridColumn: "1 / -1"
		},
		[theme.breakpoints.up("lg")]: {
			gridColumn: "3 / -1"
		}
	}
}));

export default styles;
